import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  period: {
    '@$': 'focusedRange',
  },
  selection: {
    '{}': {
      name: 'Metrics',
      type: 'report-card',
      content: {
        if: [
          [
            {
              and: [
                {
                  not: {
                    '=': [
                      {
                        '@$': 'spaceRecordId',
                      },
                      null,
                    ],
                  },
                },
                {
                  not: {
                    '=': [
                      {
                        '@$': 'spaceEntityId',
                      },
                      null,
                    ],
                  },
                },
              ],
            },
            {
              '[]': [
                {
                  '{}': {
                    name: 'Space Metrics',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'ASF',
                            value: {
                              '{}': {
                                tooltip: 'Total Assignable Square Footage',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.001,
                                      suffix: 'K',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'Total Area',
                            value: {
                              '{}': {
                                tooltip: 'Total Area',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'sqft',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'Utilization',
                            value: {
                              '{}': {
                                tooltip: 'ASF / Total Area',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '??': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'sqft',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      ',': true,
                                      '.': {
                                        max: 2,
                                        min: 2,
                                      },
                                      scalar: 100,
                                      suffix: '%',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
              ],
            },
          ],
          [
            {
              and: [
                {
                  not: {
                    '=': [
                      {
                        '@$': 'orgRecordId',
                      },
                      null,
                    ],
                  },
                },
                {
                  not: {
                    '=': [
                      {
                        '@$': 'orgEntityId',
                      },
                      null,
                    ],
                  },
                },
              ],
            },
            {
              '[]': [
                {
                  '{}': {
                    name: 'Total',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'TDC',
                            value: {
                              '{}': {
                                tooltip:
                                  'Total Direct Cost - All direct expenses charged to a research project.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC',
                            value: {
                              '{}': {
                                tooltip:
                                  'Modified Total Direct Cost - TDC excluding equipment, capital costs, patient care, tuition, and large subawards.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'IDC-R',
                            value: {
                              '{}': {
                                tooltip: 'Total Indirect Cost Recovery',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'idcrAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'ASF',
                            value: {
                              '{}': {
                                tooltip: 'Total Assignable Square Footage',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'totalAsf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.001,
                                      suffix: 'K',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  '{}': {
                    name: 'Density',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'TDC Density',
                            value: {
                              '{}': {
                                tooltip: 'Total TDC / Total ASF',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdcDensity',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC Density',
                            value: {
                              '{}': {
                                tooltip: 'Total MTDC / Total ASF',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdcDensity',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'IDC-R Density',
                            value: {
                              '{}': {
                                tooltip: 'Total IDC-R / Total ASF',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'idcrDensity',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  '{}': {
                    name: 'Other',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'Utilization',
                            value: {
                              '{}': {
                                tooltip:
                                  'Percentage of ASF actively used for research.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'utilization',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      ',': true,
                                      '.': {
                                        max: 2,
                                        min: 2,
                                      },
                                      scalar: 100,
                                      suffix: '%',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'Effective Recovery',
                            value: {
                              '{}': {
                                tooltip: 'IDC-R / MTDC',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '??': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'org',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'idcrAmount',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'org',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      ',': true,
                                      '.': {
                                        max: 2,
                                        min: 2,
                                      },
                                      scalar: 100,
                                      suffix: '%',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
              ],
            },
          ],
          [
            {
              not: {
                '=': [
                  {
                    '@$': 'piRecordId',
                  },
                  null,
                ],
              },
            },
            {
              '[]': [
                {
                  '{}': {
                    name: 'Total',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'TDC',
                            value: {
                              '{}': {
                                tooltip:
                                  'Total Direct Cost - All direct expenses charged to a research project.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'pi',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC',
                            value: {
                              '{}': {
                                tooltip:
                                  'Modified Total Direct Cost - TDC excluding equipment, capital costs, patient care, tuition, and large subawards.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'pi',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'IDC-R',
                            value: {
                              '{}': {
                                tooltip: 'Total Indirect Cost Recovery',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'pi',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'idcrAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
              ],
            },
          ],
          {
            '[]': [
              {
                '{}': {
                  name: 'Total',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'TDC',
                          value: {
                            '{}': {
                              tooltip:
                                'Total Direct Cost - All direct expenses charged to a research project.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projectsGlExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'MTDC',
                          value: {
                            '{}': {
                              tooltip:
                                'Modified Total Direct Cost - TDC excluding equipment, capital costs, patient care, tuition, and large subawards.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projectsGlExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'IDC-R',
                          value: {
                            '{}': {
                              tooltip: 'Total Indirect Cost Recovery',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projectsGlExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'idcrAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'ASF',
                          value: {
                            '{}': {
                              tooltip: 'Total Assignable Square Footage',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    scalar: 0.001,
                                    suffix: 'K',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Density',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'TDC Density',
                          value: {
                            '{}': {
                              tooltip: 'Total TDC / Total ASF',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '??': [
                                      {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'tdcAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'MTDC Density',
                          value: {
                            '{}': {
                              tooltip: 'Total MTDC / Total ASF',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '??': [
                                      {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'mtdcAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'IDC-R Density',
                          value: {
                            '{}': {
                              tooltip: 'Total IDC-R / Total ASF',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '??': [
                                      {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'idcrAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Other',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Utilization',
                          value: {
                            '{}': {
                              tooltip:
                                'Percentage of ASF actively used for research.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '??': [
                                      {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'sqft',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                    scalar: 100,
                                    suffix: '%',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Effective Recovery',
                          value: {
                            '{}': {
                              tooltip: 'IDC-R / MTDC',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '??': [
                                      {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'idcrAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'mtdcAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                    scalar: 100,
                                    suffix: '%',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
        ],
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2023',
        },
        start: {
          $date: '1/1/2023',
        },
      },
    },
  },
  subqueries: {
    pi: {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            not: {
              '=': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                null,
              ],
            },
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  tdcAmount: {
                    '@.': '!amount',
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    org: {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          totalSqft: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'sqft',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          idcrAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'idcrAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'tdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          idcrDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'idcrAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          mtdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'mtdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          utilization: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'totalAsf',
                  },
                  {
                    '@>': 'totalSqft',
                  },
                ],
              },
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          using: 'orgSpaceAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            not: {
              '=': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                null,
              ],
            },
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              idcrAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'idcrAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  tdcAmount: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@': 'costType',
                              },
                              'IDC',
                            ],
                          },
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  idcrAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!cost_type',
                  },
                },
              },
            },
          },
        },
        orgSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
            inherit: '-',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    rooms: {
      filter: {
        and: [
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceEntityId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'spaceEntityId',
                            },
                            'ent:!space:!campus',
                          ],
                        },
                        {
                          '@^': '!campus',
                        },
                      ],
                      [
                        {
                          '=': [
                            {
                              '@$': 'spaceEntityId',
                            },
                            'ent:!space:!bldg',
                          ],
                        },
                        {
                          '@^': '!bldg',
                        },
                      ],
                      [
                        {
                          '=': [
                            {
                              '@$': 'spaceEntityId',
                            },
                            'ent:!space:!floor',
                          ],
                        },
                        {
                          '@^': '!floor',
                        },
                      ],
                      {
                        '@.': '!id',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!space:!room',
      selection: {
        '{}': {
          asf: {
            '*': [
              {
                '@.': '!sqft',
              },
              {
                '/': [
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '*': [
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'allowable',
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  },
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '@>': [
                            {
                              '@$': '$value',
                            },
                            'value',
                          ],
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
          sqft: {
            '@.': '!sqft',
          },
        },
      },
      subqueries: {
        weights: {
          ref: {
            attr: 'attr:ent#!space_funcl#!entry:!space',
            inherit: '-',
          },
          filter: {
            '!=': [
              {
                '@.': '!weight',
              },
              0,
            ],
          },
          target: 'ent:!space_funcl:!entry',
          selection: {
            '{}': {
              value: {
                '@.': '!weight',
              },
              allowable: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@': 'funcIdCat',
                        },
                        null,
                      ],
                    },
                    1,
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            funcIdCat: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!func_space',
              },
              target: 'ent:!func_space:!func',
              selection: {
                '@.': [
                  '!func_idc',
                  {
                    ref: {
                      entity: '!cat',
                    },
                  },
                ],
              },
            },
          },
        },
        roomOrgs: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    projectsGlExpenses: {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceEntityId',
                  },
                  null,
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          tdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'tdcAmount',
                  ],
                },
              ],
            },
          },
          idcrAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'idcrAmount',
                  ],
                },
              ],
            },
          },
          mtdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              tdcAmount: {
                if: [
                  [
                    {
                      not: {
                        '=': [
                          {
                            '@': 'costType',
                          },
                          'IDC',
                        ],
                      },
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              idcrAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'IDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!cost_type',
              },
            },
          },
        },
      },
    },
  },
}
